import { isEmptyString } from '@/utils/validations'
import { City } from './types'

export function sortByNameMn <T extends { nameMn: string }> (items: T[]): T[] {
  return [...items].sort((a, b) => {
    if (a.nameMn < b.nameMn) return -1
    if (a.nameMn > b.nameMn) return 1
    return 0
  })
}

export function sortCities (cities: City[]): City[] {
  return [...cities].sort((a, b) => {
    if (a.type === 'City' && b.type !== 'City') return -1
    if (a.type !== 'City' && b.type === 'City') return 1
    if (a.nameMn < b.nameMn) return -1
    if (a.nameMn > b.nameMn) return 1
    return 0
  })
}

export function toOptional (value?: string): string | undefined {
  return !isEmptyString(value) ? String(value) : undefined
}

export function localeName (item: { nameMn: string, nameEn: string }, locale: string): string {
  return locale === 'en' ? item.nameEn : item.nameMn
}

export function getDistance (lat1: number, lon1: number, lat2: number, lon2: number): number {
  const p = 0.017453292519943295
  const c = Math.cos
  const a = 0.5 - c((lat2 - lat1) * p) / 2 + c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p)) / 2
  return 12742 * Math.asin(Math.sqrt(a))
}
